import Select from '../../select/show';

export default Select;
